"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Merchant {
}
exports.default = Merchant;
//# sourceMappingURL=Merchant.js.map